<template lang="pug">
div
  ListOVE
</template>

<script>
import ListOVE from '../../components/OVE/ListOVE.vue'

export default {
  name: 'ListOVEView',
  components: {
    ListOVE,
  },
}
</script>

<style lang="scss" scoped></style>
